// extracted by mini-css-extract-plugin
module.exports = {"cover":"CoverImage--cover--JpAov"};